import React from "react";
import SidebarTenagaKesehatan from "../../components/SidebarTenagaKesehatan";
import TopBarAnalitikTK from "../../components/TopBarAnalitikTK";
import RingkasanAnalitikTK from "../../components/RingkasanAnalitikTK";
import "../../CSS/SemuaDataPasienTK.css";

function HalamanRingkasanAnalitik() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarTenagaKesehatan />

      {/* Area kanan */}
      <div className="content">
        <TopBarAnalitikTK />

        {/* Konten utama */}
        <div className="ringkasan-page">
          <RingkasanAnalitikTK />
        </div>
      </div>
    </div>
  );
}

export default HalamanRingkasanAnalitik;
